<template>
  <div class="container">
    <debt-level-datatable />
  </div>
</template>

<script>
import DebtLevelDatatable from "./debt_level_datatable/Index.vue";

export default {
  name: "DebtLevelIndex",
  components: { DebtLevelDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {},
    create() {},
    refresh() {},
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
